import React from 'react';
import { useHistory } from 'react-router-dom';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import PaymentCreditDebitCardViewTemplates from 'organisms/Payment/presentation/templates/PaymentCreditDebitCardViewTemplates';
import GlobalPaymentView from 'organisms/Payment/presentation/GlobalPaymentView';
import { redirectBackToPayment } from '../utils/AddNewCardUtils';

const GlobalPaymentAddCardTemplate = props => {
  const { paymentDetails, updateSaveCardDetails } = props;

  const history = useHistory();
  const params = { checkoutDetails: paymentDetails, updateCheckoutDetails: updateSaveCardDetails, history };
  return (
    <>
      <PaymentCreditDebitCardViewTemplates
        {...props}
        checkoutDetails={paymentDetails}
        updateCheckoutDetails={updateSaveCardDetails}
        fromAccountpage={true}
      />
      <div className='hidden'>
        <GlobalPaymentView {...params} />
      </div>
      <div className='row globalpayment-add-new-card'>
        <div className='col-sm-4 col-12'>
          <div id='add-new-card-cont'>
            <div className='payment-place-order-cont-label'>
              <lable
                className={`payment-place-order-label ${
                  paymentDetails?.paymentCardDetails?.isFormValid &&
                  paymentDetails?.billingAddressAndSaveCard?.isBillingAddressFormDetailsValid &&
                  !paymentDetails?.cardNickNameError
                    ? 'addCardValid'
                    : ''
                }`}
              >
                {translateWithI18Next(TRANSLATE_MAPPING_KEY?.SAVE)}
              </lable>
            </div>
            <div
              id='payment-provider-place-order-form'
              className={`${
                !(
                  paymentDetails?.paymentCardDetails?.isFormValid &&
                  paymentDetails?.billingAddressAndSaveCard?.isBillingAddressFormDetailsValid
                )
                  ? 'addCardInValid'
                  : ''
              }`}
            ></div>
          </div>
        </div>
        <div className='col-sm-4 col-12'>
          <div className='add-cancel-button'>
            <div
              className='mt-10 button font-bold whiteButton blackBorder'
              data-testid='add-cancel-button'
              onClick={() => redirectBackToPayment(history)}
            >
              {translateWithI18Next(TRANSLATE_MAPPING_KEY?.CANCEL)}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GlobalPaymentAddCardTemplate;
